import Image from 'next/image';
import { cn } from '@/lib/utils';

export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2 font-bold", className)}>
        <Image
          alt="Whisk Logo"
          className="h-8 w-8"
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuDyUusEknN48VFzKrv3Z80L4Y-NuhZk3NHvJZr2JreOCzzhL9GWy_NPyoM9JH-zxZQ-KRXMOJP1A4Lk9DGCxXf4kS0GC-8Bfuv9iy7o495RBRIJCtNET19jWoCrkvycv8mzKSlOnEM7oiH5j5Z9gleLvCyJ52fCUeLluJKkIs8_lNuoQ8XWnVucIStl043vsw6PqfKwKXsj_B8qJdBlCglgTa9-Nbll13Lr78Jf_ZXmch77P0gZuzY7MVMkgCigHt2A0hc8PPWeQGc"
          width={32}
          height={32}
          unoptimized
        />
        <h1 className="text-2xl text-foreground">Whisk</h1>
    </div>
  );
}
